"use client";

import {useAppDispatch, useAppSelector} from "src/app/hooks";
import {styles} from "src/app/features/theme";
import React from "react";
// import {setBackground, ThemeType} from "@/lib/features/theme/slice";

export default function ThemeWrapper({children}: { children: React.ReactNode }) {
    const dispatch = useAppDispatch();
    // const changeToDark = () => dispatch(setBackground(ThemeType.DARK));
    // const changeToLight = () => dispatch(setBackground(ThemeType.LIGHT));
    const background = useAppSelector((state) => state.theme.background);
    const theme = useAppSelector((state) => state.theme.theme);

    React.useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme); // Устанавливаем атрибут data-theme
    }, [theme]);

    return <div
        className={styles.main}
        style={{
            'backgroundImage': `url(${background})` as string,
        } as React.CSSProperties}>
        {/*<button onClick={changeToDark}>DARK</button>*/}
        {/*<button onClick={changeToLight}>LIGHT</button>*/}
        {children}</div>;
}